import { render, staticRenderFns } from "./CartOrcamento.vue?vue&type=template&id=062b6362&"
import script from "./CartOrcamento.vue?vue&type=script&lang=js&"
export * from "./CartOrcamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports